import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";

import { SAFE_HTTP_METHODS } from "../../constants";
import {
  readBrowserCookie,
  SESSION_CSRF_COOKIE_NAME,
  SESSION_CSRF_HEADER_NAME,
} from "../auth/session-cookie.constants";
import { apiBaseUrl } from "../env.helpers";
import { normalizeUrlBasePath } from "../url.helpers";
import { isRydeApiRequestUri } from "./ryde-api-axios-request.helpers";

let isAxiosInterceptorInitialized = false;

const getRydeApiBaseUrlNormalized = (): string | undefined => {
  const raw = apiBaseUrl()?.trim();
  if (!raw) {
    return undefined;
  }
  return normalizeUrlBasePath(raw);
};

const shouldAttachRydeSessionCsrfHeader = (
  config: InternalAxiosRequestConfig,
): boolean => {
  let requestUri: string;
  try {
    requestUri = axios.getUri(config);
  } catch {
    return false;
  }
  return isRydeApiRequestUri({
    requestUri,
    rydeApiBase: getRydeApiBaseUrlNormalized(),
  });
};

export const installAxiosSessionDefaults = (): void => {
  if (isAxiosInterceptorInitialized) {
    return;
  }
  isAxiosInterceptorInitialized = true;

  axios.defaults.withCredentials = true;

  axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const method = (config.method ?? "get").toUpperCase();

    if (
      !SAFE_HTTP_METHODS.has(method) &&
      shouldAttachRydeSessionCsrfHeader(config)
    ) {
      const csrf = readBrowserCookie(SESSION_CSRF_COOKIE_NAME);
      if (csrf) {
        config.headers ??= new AxiosHeaders();
        config.headers.set(SESSION_CSRF_HEADER_NAME, csrf);
      }
    }

    return config;
  });
};
